import { Breadcrumbs, BreadcrumbsItem } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import React from 'react';
import { TEST_IDS } from '../../../testIds';
const SearchBreadcrumbs = () => {
  const history = useHistory();
  const handleBreadcrumbsClick = event => {
    event.preventDefault();
    history === null || history === void 0 ? void 0 : history.push('/');
  };
  return /*#__PURE__*/React.createElement(Breadcrumbs, {
    testId: TEST_IDS.SEARCH_PAGE_BREADCRUMBS
  }, /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    href: "/",
    onClick: handleBreadcrumbsClick,
    text: "Marketplace"
  }), /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    text: "Search",
    onClick: e => e.preventDefault()
  }));
};
export default SearchBreadcrumbs;